/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileStatusEnum } from './FileStatusEnum';
import {
    FileStatusEnumFromJSON,
    FileStatusEnumFromJSONTyped,
    FileStatusEnumToJSON,
    FileStatusEnumToJSONTyped,
} from './FileStatusEnum';

/**
 * Serializer for the EventAttachment model.
 * @export
 * @interface EventFile
 */
export interface EventFile {
    /**
     * 
     * @type {string}
     * @memberof EventFile
     */
    readonly id: string;
    /**
     * 
     * @type {number}
     * @memberof EventFile
     */
    readonly owner: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFile
     */
    readonly event: string;
    /**
     * 
     * @type {number}
     * @memberof EventFile
     */
    uploadedBy?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventFile
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EventFile
     */
    file: string;
    /**
     * Returns filename to API.
     * @type {string}
     * @memberof EventFile
     */
    readonly filename: string;
    /**
     * 
     * @type {FileStatusEnum}
     * @memberof EventFile
     */
    fileStatus?: FileStatusEnum;
}



/**
 * Check if a given object implements the EventFile interface.
 */
export function instanceOfEventFile(value: object): value is EventFile {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('event' in value) || value['event'] === undefined) return false;
    if (!('file' in value) || value['file'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    return true;
}

export function EventFileFromJSON(json: any): EventFile {
    return EventFileFromJSONTyped(json, false);
}

export function EventFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventFile {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'owner': json['owner'],
        'event': json['event'],
        'uploadedBy': json['uploaded_by'] === undefined ? undefined : json['uploaded_by'] === null ? null : json['uploaded_by'],
        'description': json['description'] == null ? undefined : json['description'],
        'file': json['file'],
        'filename': json['filename'],
        'fileStatus': json['file_status'] == null ? undefined : FileStatusEnumFromJSON(json['file_status']),
    };
}

export function EventFileToJSON(json: any): EventFile {
    return EventFileToJSONTyped(json, false);
}

export function EventFileToJSONTyped(value?: Omit<EventFile, 'id'|'owner'|'event'|'filename'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploaded_by': value['uploadedBy'],
        'description': value['description'],
        'file': value['file'],
        'file_status': FileStatusEnumToJSON(value['fileStatus']),
    };
}

